import React, {useMemo} from 'react';
import Button from '@mui/material/Button';
import useApiControl from '../../../common/useApiControl';

function BetStartButton(props) {

    const params = useMemo(() => ({
        eid: props.event.id,
        round: props.round.number,
    }), [props.event.id, props.round.number]);

    const { executeRequest: executeRequest1 } = useApiControl({
        action: '/start_round',
        params: params,
        method: 'POST',
    });

    const handleStartClick = () => {
        props.onRequestStart();

        executeRequest1()
            .then(() => {
                props.onStart();
            })
            .catch(error => {
                console.error('Error starting round:', error);
                const message = error?.response?.data?.message || 'ベット開始に失敗しました。';
                props.onRequestFailed(message);
            });
    };

    const shouldDisable =
        props.round.answers == '[]' ||
        (props.round.starttime !== null && props.round.starttime !== '') ||
        props.sharedDisabled;

    return (
        <Button variant="contained" color="primary" onClick={handleStartClick} disabled={shouldDisable}>
            ベット開始
        </Button>
    );
}


export default BetStartButton;
